import { CVAMarketingContentProps } from "../types";

export const CVAMarketingContent = ({
    className,
    children,
}: CVAMarketingContentProps) => {
    return (
        <div data-testid="cvaContentCard" className={className}>
            {children}
        </div>

    );
};
